<div class="container-fluid py-4">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h4 class="mb-0">
      <i class="bi bi-calendar text-warning me-2"></i>{{ 'admin.reservations.list_title' | translate }}
    </h4>
  </div>

  <div class="card">
    <div class="card-body">
      <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" (activeIdChange)="onTabChange()" class="nav-tabs">
        <li [ngbNavItem]="1">
          <a ngbNavLink>
            <i class="bi bi-calendar-day me-2"></i>{{ 'admin.reservations.tab_today' | translate }}
          </a>
          <ng-template ngbNavContent>
            <s-table [cols]="tabToday.cols" [refreshUrl]="tabToday.refreshUrl"
              [detailUrl]="tabToday.detailUrl" [detailId]="tabToday.detailId"
              [params]="tabToday.params" [showPageSize]="!shared.isMobileConst">
            </s-table>
          </ng-template>
        </li>
        <li [ngbNavItem]="2">
          <a ngbNavLink>
            <i class="bi bi-clock me-2"></i>{{ 'admin.reservations.tab_upcoming' | translate }}
          </a>
          <ng-template ngbNavContent>
            <s-table [cols]="tabUpcoming.cols" [refreshUrl]="tabUpcoming.refreshUrl"
              [detailUrl]="tabUpcoming.detailUrl" [detailId]="tabUpcoming.detailId"
              [params]="tabUpcoming.params" [showPageSize]="!shared.isMobileConst">
            </s-table>
          </ng-template>
        </li>
        <li [ngbNavItem]="3">
          <a ngbNavLink>
            <i class="bi bi-list me-2"></i>{{ 'admin.reservations.tab_all' | translate }}
          </a>
          <ng-template ngbNavContent>
            <s-table [cols]="tabAll.cols" [refreshUrl]="tabAll.refreshUrl"
              [detailUrl]="tabAll.detailUrl" [detailId]="tabAll.detailId"
              [showPageSize]="!shared.isMobileConst">
            </s-table>
          </ng-template>
        </li>
      </ul>
      <div [ngbNavOutlet]="nav" class="mt-3"></div>
    </div>
  </div>
</div>
